import { useQuery } from '@tanstack/react-query';
import { ExternalLink, Link2, LifeBuoy } from 'lucide-react';
import { portalQueries } from '@blimo/api-client';
import { useApi } from '@blimo/api-client/react';
import { EmptyState, ErrorState, Skeleton } from '@blimo/ui';
import { PageHeader } from '../components/ui/page-header.jsx';
import { ItemList, ItemRow, Section } from '../components/ui/section.jsx';

/** Service (F-1003): nützliche Links der Verwaltung, gruppiert nach Kategorie. */
export function ServicePage() {
  const api = useApi();
  const query = useQuery(portalQueries.links(api));

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Service" description="Nützliche Links und Informationen Ihrer Verwaltung." />
      {query.error ? (
        <ErrorState error={query.error} onRetry={() => query.refetch()} />
      ) : query.isPending ? (
        <Skeleton className="h-48 w-full" />
      ) : query.data.length === 0 ? (
        <EmptyState icon={LifeBuoy} title="Noch keine Links" description="Ihre Verwaltung hat noch keine Links hinterlegt." />
      ) : (
        <div className="grid items-start gap-4 lg:grid-cols-2">
          {query.data.map((category) => (
            <Section key={category.id ?? 'other'} title={category.name} flush>
              <ItemList>
                {(category.links ?? []).map((link) => (
                  <li key={link.id}>
                    <ItemRow
                      as="a"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      icon={Link2}
                      chevron={false}
                      title={
                        <>
                          {link.name}
                          <span className="sr-only"> (öffnet in neuem Tab)</span>
                        </>
                      }
                      subtitle={link.description || undefined}
                      accessory={<ExternalLink className="size-4 text-muted-foreground" aria-hidden="true" />}
                    />
                  </li>
                ))}
              </ItemList>
            </Section>
          ))}
        </div>
      )}
    </div>
  );
}
